import React from "react";
import { PostsPage } from "../components/PostsPage";

export default function Events() {
  return (
    <PostsPage
      type="events"
      overline="What's on"
      title="Events"
      subtitle="Tournaments, social nights, come-and-try sessions and holiday programmes across the region."
      emptyText="No events scheduled just yet — check back soon."
    />
  );
}
